import React, { SVGProps } from 'react';

const CollectionPlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <g clipPath="url(#clip0_6790_17470)">
        <path
          d="M15.6475 12.3535H0.820374V25.5332H15.6475M15.6475 12.3535V25.5332M15.6475 12.3535V2.46875H5.76276V12.3535H15.6475ZM15.6475 25.5332H27.1797V15.6484H15.6475M15.6475 25.5332V15.6484M15.6475 15.6484H25.5323V5.76367H15.6475V15.6484ZM9.05768 5.76367H12.3526M5.76276 15.6484H10.7051M18.9424 9.05859H22.2374M19.585 18.9434H23.2422"
          stroke="black"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00006 24C10.7615 24 13.0001 21.7614 13.0001 19C13.0001 16.2386 10.7615 14 8.00006 14C5.23864 14 3.00006 16.2386 3.00006 19C3.00006 21.7614 5.23864 24 8.00006 24Z"
          fill="white"
          stroke="#29845A"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M8.00011 16.5298V21.4677M10.4691 18.9987H5.53119"
          stroke="#29845A"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6790_17470">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CollectionPlusIcon;
